import axios from "axios";

export default axios.create({
  // baseURL: "http://127.0.0.1:8000/api/v1",
  // baseURL: 'https://cf4e-85-255-236-246.eu.ngrok.io/api/v1',
  baseURL: 'https://api.xtrava.africa/api/v1',
  headers: {
    "Content-type": "application/json"
  }
});